/**
 * Normalize a translation token so that a lookup finds the row that was
 * actually stored for it.
 *
 * Translations live in `_translation._token`, which collates
 * `utf8mb4_0900_ai_ci` under a unique (language, token) index. That collation
 * folds case AND expands `…` into three dots, so the table physically cannot
 * hold both `Sending...` and `Sending…` for one language — yet both are real
 * keys this codebase passes to `t()`. Folding the same two differences at
 * lookup time lets the single stored row answer either spelling, and revives
 * rows that were entered with the other spelling and so had stopped matching.
 *
 * Only the differences the database itself folds are applied; this is not an
 * attempt to reimplement the collation.
 */
export function normalizeTranslationKey(key: string): string {
	return key.toLowerCase().replace(/…/g, '...');
}
